<template>
	<div class="details-list">
		<span class="details-list__title"> {{ data.title }}</span>
		<div class="details-list__wrap">
			<ul class="details-list__list">
				<template v-for="(item, index) in data.items">
					<li class="details-list__item" :key="index" v-if="item.name && !item.hide">
						<span class="details-list__name">
							{{ item.name }}
						</span>
						<a class="details-list__information external-link" :href="parseUrl(item.information)" v-if="item.name === 'Property Shark Link' && item.information" target="_blank" rel="noopener">
							{{ parseUrl(item.information) }}
						</a>
						<span v-else class="details-list__information">
							{{ prepareItem(item.information) }}
						</span>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	methods: {
		prepareItem(item) {
			if (item) {
				if (Array.isArray(item)) {
					let newItem;
					for (let i = 0; i < item.length; i++) {
						newItem += `, ${item[i]}`;
					}
					if (newItem !== undefined) {
						newItem = newItem.substr(newItem.indexOf(',') + 1);
					}

					return newItem;
				} else {
					return item;
				}
			}
		},
		parseUrl(item) {
			if (!(item.startsWith('http://') || item.startsWith('https://'))) {
				item = 'https://' + item;
			}
			return item;
		}
	}
};
</script>

<style lang="scss" scoped>
.details-list {
	margin-bottom: 19px;
}

.details-list__title {
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 1px;
	font-family: $font-main;
	display: block;
	color: $fiord;
	background-color: $grey-light;
	padding: 10px 20px;
	
	@include mq($xl) {
		padding: 10px 15px;
	}
}
.details-list__item {
	display: flex;
	margin-bottom: 8px;
	border-bottom: 1px solid $grey-light;

	@include mq(1500px) {
		margin-bottom: 5px;
		align-items: flex-start;
	}

	span {
		font-size: 14px;
		line-height: 1.2;

		@include mq(1440px) {
			font-size: 12px;
			line-height: 1.1;
		}
	}
}

.details-list__list {
	margin-bottom: 0;
	background-color: $white;
	padding: 22px 20px;
	border-right: none;
	border-left: none;
	display: block;

	@include mq(1500px) {
		padding: 20px 15px;
	}

	@include mq($xl) {
		padding: 15px;
	}
}

.details-list__name,
.details-list__information {
	font-family: $font-main;
	font-weight: normal;
	display: block;
	font-size: 14px;
}

.details-list__name {
	flex: 0 0 41%;
	max-width: 41%;
	color: $slate-gray;
	opacity: 0.6;
	margin-right: 5px;

	@include mq(1500px) {
		flex: 0 0 50%;
		max-width: 50%;
	}
}

.details-list__information {
	color: $fiord;
	margin-left: auto;
	text-align: right;
	&.external-link {
		color: $dodger-blue;
		display: flex;
		word-break: break-all;
		font-size: 14px;
		line-height: 1.2;
		transition: $dur $ease;

		@include mq(1440px) {
			font-size: 12px;
			line-height: 1.1;
		}

		&:hover {
			text-decoration: underline;
		}
	}
}

.details-list__information--link {
	text-decoration: none;
	transition: $dur $ease;

	@include hover {
		color: $dodger-blue;
	}
}
</style>
